module.exports = __webpack_public_path__ + "img/谢谢参与.6c8ae11d.png";